export default __webpack_public_path__ + "static/media/cake2.b4140460.jpg";